import { produce } from 'immer'
import { dispatch } from '@rematch/core'
import api from './api'

export default {
    state: {
        roles: [ ],
        organisationId: 0
    },

    reducers: {
        setProfile: produce((draft, profile = { roles: [], organisationId: 0 }) => {
            draft.roles = profile.roles
            draft.organisationId = profile.organisationId
        })
    },

    selectors: {
        roles(state) {
            return state.profile.roles
        },

        organisationId(state) {
            return state.profile.organisationId
        }
    },

    effects: {
        async load() {
            const res = await api.get()

            if (res && res.data) {
                dispatch.profile.setProfile({
                    roles: res.data.roles,
                    organisationId: res.data.organisatieId
                })
            }
        }
    }
}
